import { isNumber } from '@mote/helpers'
import { DiagnosticsLogger } from '@mote/helpers/diagnostics'
import React from 'react'
import styled, { css } from 'styled-components'
import { useAudioAnimation } from './useAudioAnimation'

const logD = DiagnosticsLogger('audioAnimation')

export const AudioAnimation = ({ audioStream, audioContext, children }) => {
  const { beginAnimation, endAnimation, amplitude } = useAudioAnimation(
    audioContext,
    audioStream
  )
  const childRef = React.useRef(null)

  React.useEffect(() => {
    try {
      beginAnimation()
    } catch (error) {
      logD.error('Caught exception: Failed to start audio animation', { error })
    }

    return () => {
      endAnimation()
    }
  }, [audioStream, audioContext])

  return (
    <span
      className='reactive-audio__container'
      style={{ position: 'relative' }}
    >
      <span
        className='reactive-audio__content'
        style={{ position: 'relative', zIndex: '1' }}
        ref={childRef}
      >
        {children}
      </span>

      <ReactiveBGCircle
        className='reactive-audio__indicator'
        width={childRef.current?.clientWidth}
        height={childRef.current?.clientHeight}
        style={{ transform: `scale(${limitAmplitude(amplitude)})` }}
      />
    </span>
  )
}

const limitAmplitude = (amplitude, amplitudeMax = 1.8) => {
  const newAmplitude = 1 + amplitude * 3
  if (newAmplitude > amplitudeMax) {
    return amplitudeMax
  }
  return newAmplitude
}

const ReactiveBGCircle = styled.span`
  height: 100%;
  width: 100%;
  opacity: 0.2;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 0;
  background: #ac0ae8;
  border-radius: 100%;
  transition: transform 150ms ease-in-out;

  ${({ width, height }) => {
    if (!(width || height)) return

    return css`
      height: ${isNumber(height) ? `${height}px` : height};
      width: ${isNumber(width) ? `${width}px` : width};
    `
  }};
`
